class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;
    this.ready=true;
    this.scope=document.querySelector('product-info');
    this.button=this.querySelector('#StickyATCButton');
    this.label=this.querySelector('#StickyATCButtonText');
    this.titleElement=this.querySelector('.sticky-atc-title');
    this.singleTitle=this.titleElement.textContent;
    this.image=this.querySelector('#StickyATCImage');
    this.singleImage=this.image?.getAttribute('src');
    this.price=this.querySelector('#StickyATCPrice');
    this.compare=this.querySelector('#StickyATCComparePrice');
    this.wrapper=this.querySelector('#StickyATCWrapper');
    if(!this.scope||!this.button)return;
    this.button.addEventListener('click',()=>{
      if(this.active&&!this.active.disabled) {
        this.active.click();
       
      }
    });
    this.onEdition=()=>this.sync();
    document.addEventListener('memorra:edition-change',this.onEdition);
    this.observer=new MutationObserver(()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.sync(),50);});
    this.observer.observe(this.scope,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy']});
    this.sync();
  }
  sync(){
    const pair=this.scope.querySelector('memorra-couple');
    const couple=pair&&pair.dataset.mode==='couple';
    const localSingle=pair&&pair.dataset.currentGender==='couple'&&!couple;
    const usesPair=couple||localSingle;
    const active=usesPair?this.scope.querySelector('.mc-add'):this.scope.querySelector('product-form button[name=add]');
    if(!active)return;
    this.active=active;
    this.wrapper.setAttribute('aria-hidden','false');
    this.wrapper.inert=false;
    this.button.disabled=active.disabled||active.getAttribute('aria-disabled')==='true';
    const loading=active.classList.contains('loading')||active.form?.getAttribute('aria-busy')==='true';
    this.button.classList.toggle('is-loading',loading);
    this.querySelector('#StickyATCSpinner')?.classList.toggle('hidden',!loading);
    this.label.textContent=couple?'Add both to cart':(active.querySelector('span')?.textContent.trim()||'Add to cart');
    this.titleElement.textContent=usesPair?pair.dataset.activeTitle:this.singleTitle;
    if(this.image){this.image.src=localSingle?pair.dataset.activeImage:this.singleImage;this.image.alt=this.titleElement.textContent;}
    if(usesPair){
      this.price.textContent=new Intl.NumberFormat('en-IN',{style:'currency',currency:pair.dataset.currency}).format(Number(pair.dataset.activePrice)/100);
      this.compare.classList.add('hidden');
    }else{
      const current=this.scope.querySelector('.custom-main-price')||this.scope.querySelector('.price--on-sale .price-item--sale,.price:not(.price--on-sale) .price-item--regular');
      if(current)this.price.textContent=current.textContent;
      const compare=this.scope.querySelector('.custom-compare-price')||this.scope.querySelector('.price--on-sale .price__sale .price-item--regular');
      this.compare.classList.toggle('hidden',!compare);if(compare)this.compare.textContent=compare.textContent;
    }
  }
  disconnectedCallback(){this.observer?.disconnect();clearTimeout(this.timer);document.removeEventListener('memorra:edition-change',this.onEdition);this.ready=false;}
}
if(!customElements.get('sticky-add-to-cart'))customElements.define('sticky-add-to-cart',StickyAddToCart);
